/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./TabGroup.css'); }
var cssBaseClass = "m-tabPanel";
var TabGroup = /** @class */ (function (_super) {
    tslib_1.__extends(TabGroup, _super);
    function TabGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabGroup.prototype.render = function () {
        var _a;
        var _b = this.props, activeTab = _b.activeTab, children = _b.children, _c = _b.orientation, orientation = _c === void 0 ? "horizontal" : _c, _d = _b.sticky, sticky = _d === void 0 ? false : _d;
        return (React.createElement("div", { className: classnames((_a = {},
                _a[cssBaseClass + "-list"] = true,
                _a[cssBaseClass + "-list-isSticky"] = sticky,
                _a)), role: "tablist", "aria-orientation": orientation }, React.Children.map(children, function (child) {
            var _a;
            var casedChild = child;
            if (!casedChild) {
                return null;
            }
            return React.cloneElement(casedChild, {
                role: "tab",
                className: classnames((_a = {},
                    _a[cssBaseClass + "-tab"] = true,
                    _a[cssBaseClass + "-tab-selected"] = casedChild.props.name === activeTab,
                    _a[casedChild.props.className] = !!casedChild.props.className,
                    _a)),
                "aria-selected": casedChild.props.name === activeTab
            });
        })));
    };
    TabGroup.propTypes = {
        activeTab: PropTypes.any,
        sticky: PropTypes.bool,
        orientation: PropTypes.oneOf([
            "horizontal" // vertical not yet supported
        ])
    };
    TabGroup.defaultProps = {
        sticky: false,
        orientation: "horizontal"
    };
    return TabGroup;
}(React.Component));
exports.TabGroup = TabGroup;
var TabGroupContents = /** @class */ (function (_super) {
    tslib_1.__extends(TabGroupContents, _super);
    function TabGroupContents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.childrenCache = new Set();
        return _this;
    }
    TabGroupContents.prototype.componentWillUnmount = function () {
        /* Clear cache, to avoid memory leaks */
        this.childrenCache.clear();
    };
    TabGroupContents.prototype.renderWithCache = function () {
        var _this = this;
        var _a = this.props, activeTab = _a.activeTab, children = _a.children;
        return React.Children.map(children, function (child) {
            var casedChild = child;
            if (!casedChild) {
                return null;
            }
            var renderAsVisible = casedChild.props.name === activeTab;
            if (renderAsVisible) {
                _this.childrenCache.add(casedChild.props.name);
            }
            if (_this.childrenCache.has(casedChild.props.name)) {
                return React.cloneElement(casedChild, {
                    key: casedChild.props.name,
                    visible: renderAsVisible
                });
            }
            return null;
        });
    };
    TabGroupContents.prototype.renderActiveOnly = function () {
        var _a = this.props, activeTab = _a.activeTab, children = _a.children;
        var activeChild = React.Children.toArray(children).find(function (child) { return !!child && child.props.name === activeTab; });
        if (activeChild) {
            return activeChild;
        }
        return null;
    };
    TabGroupContents.prototype.render = function () {
        var _a = this.props.cacheInactiveTabs, cacheInactiveTabs = _a === void 0 ? false : _a;
        return (React.createElement("div", null, cacheInactiveTabs ? this.renderWithCache() : this.renderActiveOnly()));
    };
    TabGroupContents.propTypes = {
        activeTab: PropTypes.any,
        cacheInactiveTabs: PropTypes.bool
    };
    return TabGroupContents;
}(React.Component));
exports.TabGroupContents = TabGroupContents;
var TabGroupPanel = /** @class */ (function (_super) {
    tslib_1.__extends(TabGroupPanel, _super);
    function TabGroupPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabGroupPanel.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.padded, padded = _c === void 0 ? true : _c;
        return (React.createElement("div", { className: classnames(cssBaseClass, padded && cssBaseClass + "-isPadded", !visible && cssBaseClass + "-inactive"), role: "tabpanel" }, children));
    };
    TabGroupPanel.propTypes = {
        padded: PropTypes.bool,
        visible: PropTypes.bool,
        name: PropTypes.string.isRequired
    };
    TabGroupPanel.defaultProps = {
        padded: true
    };
    return TabGroupPanel;
}(React.Component));
exports.TabGroupPanel = TabGroupPanel;